import styled from 'styled-components';

import { PropertyCard, spaceMixin, token } from '@zillow/constellation';

import MediumIllustrationHouse2x from '../../../../images/MediumIllustrationHouse@2x.png';

type StyledFallbackPhotoProp = {
  alt: string;
};

export const StyledFallbackPhoto = styled.div<StyledFallbackPhotoProp>`
  height: 100%;

  background-repeat: no-repeat;
  background-position center center;
  background-size: 160px;
  background-image: url(${MediumIllustrationHouse2x});
  background-color: ${token('colors.blue200')};

  border-radius: ${token('radii.md')}px;
`;

export const StyledPropertyCard = styled(PropertyCard)`
  max-width: 100%;

  > div > div[class*='StyledPropertyCardDataWrapper'] {
    padding: ${spaceMixin('sm')};
  }
`;
